function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.338,59.28c-3.717,0-7.065,1.577-9.438,4.087L25.45,46.364c0.354-1.181,0.55-2.43,0.55-3.725 c0-1.294-0.196-2.543-0.55-3.724L54.9,21.913c2.37,2.51,5.72,4.087,9.438,4.087c7.168,0,13-5.832,13-13s-5.832-13-13-13 s-13,5.832-13,13c0,1.295,0.196,2.543,0.55,3.725L22.438,33.728C20.067,31.217,16.718,29.64,13,29.64c-7.168,0-13,5.832-13,13 s5.832,13,13,13c3.717,0,7.067-1.577,9.438-4.087l29.449,17.003c-0.354,1.182-0.55,2.43-0.55,3.725c0,7.168,5.832,13,13,13 s13-5.832,13-13S71.506,59.28,64.338,59.28 M64.338,6c3.86,0,7,3.141,7,7s-3.14,7-7,7s-7-3.141-7-7S60.478,6,64.338,6 M13,49.64 c-3.86,0-7-3.141-7-7s3.14-7,7-7s7,3.141,7,7S16.86,49.64,13,49.64 M64.338,79.28c-3.86,0-7-3.141-7-7s3.14-7,7-7s7,3.141,7,7 S68.198,79.28,64.338,79.28"
});

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 78,
    height: 87,
    viewBox: "-0.237 -0.784 78 87",
    enableBackground: "new -0.237 -0.784 78 87",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.f18b2b37.svg";
export { ForwardRef as ReactComponent };